import * as React from "react";
import DropZone from "./uploads/DropZone"

export default () => (
    <DropZone />
);